(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function tidyTextNodes(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        if (node.parentElement && /script|style|textarea/i.test(node.parentElement.tagName)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      node.nodeValue = node.nodeValue
        .replace(/,([A-Za-z])/g, ', $1')
        .replace(/;([A-Za-z])/g, '; $1')
        .replace(/:([A-Za-z])/g, ': $1')
        .replace(/\s{2,}/g, ' ');
    });
  }

  function markProductTemplate() {
    if (location.pathname.indexOf('/products/') !== -1) {
      document.documentElement.classList.add('integy-product-page-v95');
      document.body && document.body.classList.add('integy-product-page-v95');
    }
  }

  function normalizeStockChip() {
    document.querySelectorAll('.integy-chip--stock').forEach(function (chip) {
      chip.setAttribute('aria-label', 'Availability: In stock');
    });
  }

  ready(function () {
    markProductTemplate();
    tidyTextNodes(document.querySelector('[data-product-description]'));
    normalizeStockChip();
  });
})();
